/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect, useRef, useState} from 'react'
import {Tab, Tabs} from 'react-bootstrap'
import {useLocation, useNavigate} from 'react-router-dom'
import './CreateScratch.scss'
import {useDispatch, useSelector} from 'react-redux'
import WebLink from './WebLink'
import {KTSVG, toAbsoluteUrl} from '../../../../../_metronic/helpers'
import WSButton from '../../../../../_metronic/helpers/components/WSButton/WSButton'
import MessageBoxV2 from '../../../../Components/MessageBoxV2'
import GiphyPopup from '../../../Common/GiphyPopup/GiphyPopup'
import {CreateNewTemplate, EditTemplate} from './CreateScratchSlices/CreateScratchSlices'
import Select from 'react-select'
import {openPopup} from '../../../../Components/PopupSlice/popupSlice'
import {base64ToBlob, blobToFile} from '../../../../Utils/file'
import {removeOptOutOrReply} from '../../../../Utils/_helpers'
import {IndustryOptions} from '../../../AdminPages/AllCellCastUser/Constant/CellCastConstant'
import {getAllUserDetails} from '../../accounts/Overview/OverviewSlice/UserDetailsSlice'
import {GetData} from '../../Contacts/AllContactsList/SubscriberSlice/SubscriberSlice'

const categoryOptions = [
  {value: 'GENERAL', label: 'General'},
  {value: 'REVIEW', label: 'Review'},
  // {value: 'EMAIL', label: 'Email'},
  // {value: 'WHATSAPP', label: 'WhatsApp'},
]

type CreateScratchProps = {
  shouldDirectAfterSave?: boolean
  onSave?: (newTemplate?: any) => void
  isEdit?: boolean
  id?: string
  templateData?: any
  data?: any
  hideMMS?: boolean
}

const MAX_FILE_SIZE = 1572864 //1048576;

const CreateScratchV2 = ({
  shouldDirectAfterSave = true,
  onSave,
  isEdit = false,
  id,
  templateData,
  data,
  hideMMS = true,
}: CreateScratchProps) => {
  const aRef: any = useRef(null)
  const mediaInputVideo: any = useRef(null)
  const inputRef: any = useRef()
  const dispatch = useDispatch()
  const param: any = useLocation()
  const navigate = useNavigate()
  const [error, setError] = useState<any>({})

  const [giphypopup, setGiphypopup] = useState<any>(false)
  const [popup, setPopup] = useState({
    webLink: false,
    customLanding: false,
    optout: false,
  })
  const [options, setOptions] = useState({
    webLink: [
      {
        value: '',
        label: (
          <button
            onClick={() => {
              setPopup({...popup, webLink: true})
            }}
          >
            Create
          </button>
        ),
      },
      {value: 'https/', label: 'link2'},
      {value: 'https', label: 'link3'},
    ],
    customLanding: [
      {
        value: '',
        label: (
          <button
            onClick={() => {
              setPopup({...popup, customLanding: true})
            }}
          >
            Create
          </button>
        ),
      },
      {value: 'https/', label: 'link2'},
      {value: 'https', label: 'link3'},
    ],
    optOut: [
      {
        value: '',
        label: (
          <button
            onClick={() => {
              setPopup({...popup, optout: true})
            }}
          >
            Create
          </button>
        ),
      },
      {value: "Reply 'STOP' to opt-out ", label: 'Reply Stop'},
      {value: 'STOP:{stoptxt.cc/}', label: 'custom survey'},
    ],
  })

  const [userMessage, setUserMessage] = useState<any>({
    type: 'SMS',
    name: '',
    subjectTitle: '',
    createdAt: '',
    message: '',
    media: '',
    allowShortUrl: '',
    qr_code: '',
    optout: '',
    gif: '',
    mediaType: '',
    industry: {value: '', label: 'Select Industry'},
    affiliate: '',
    scope: 'GLOBAL',
    category: 'GENERAL',
    longUrl: [],
  })

  const userDetails = useSelector(getAllUserDetails)
  const userRole = userDetails?.role
  const isAdmin = ['superAdmin', 'accountManager', 'subAdmin', 'sales', 'affiliate'].includes(
    userRole
  )

  useEffect(() => {
    const stateData = param?.state?.data || {}
    const newPayload = {...userMessage, ...stateData, ...templateData}

    if (stateData.base64media && stateData.media && stateData.mediaType) {
      const fileName = stateData.media.split('/').pop()
      const blob = base64ToBlob(stateData.base64media, stateData.mediaType)
      const file = blobToFile(blob, fileName)
      newPayload.media = file
    }

    if (templateData?.industry || stateData?.industry) {
      newPayload.industry = IndustryOptions.find(
        (option) => option.value === (templateData?.industry || stateData?.industry)
      ) || {value: '', label: 'Select Industry'}
    }
    setUserMessage(newPayload)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [param?.state?.data, templateData])

  const handleChange = (e: any) => {
    if (e.label) {
      let content = userMessage.message + e.value
      setUserMessage({...userMessage, message: content})
      inputRef?.current.focus()
    } else {
      setUserMessage({...userMessage, [e.target.name]: e.target.value})
    }
  }

  const handleSave = () => {
    let MsgData = validationOfquickmsg(userMessage)

    if (Object.keys(MsgData).length === 0) {
      let data = new FormData()

      const selectedIndustry = userMessage?.industry?.value || ''

      delete userMessage.industry
      delete userMessage?.base64media

      for (var key in userMessage) {
        let value = userMessage[key] ?? ''

        if (Array.isArray(value)) {
          value = JSON.stringify(value)
        }

        data.append(key, value)
      }

      data.append('isAdmin', isAdmin.toString())
      if (isAdmin) {
        data.append('industry', selectedIndustry)
      }

      if (param?.state?.data?._id === undefined && !isEdit) {
        dispatch(CreateNewTemplate(data)).then((res: any) => {
          if (res?.payload && res.payload.data) {
            onSave?.(res.payload.data)
          } else {
            onSave?.()
          }
        })
        if (shouldDirectAfterSave) {
          isAdmin ? navigate('/templates/message-template') : navigate('/templates/template')
        }
      } else {
        const idEdit = param?.state?.data?._id || id
        dispatch(EditTemplate({id: idEdit, data})).then((res: any) => {
          if (res?.payload && res.payload.data) {
            onSave?.(res.payload.data)
          } else {
            onSave?.()
          }
        })
        if (shouldDirectAfterSave) {
          isAdmin ? navigate('/templates/message-template') : navigate('/templates/template')
        }
      }
    }
  }
  const validationOfquickmsg = (value: any) => {
    const err: any = {}

    if (value?.name?.trim() === '') {
      err.name = 'Template name is required'
    }

    if (value?.contacts?.length === 0) {
      err.contacts = 'Please add contacts'
    }

    if (value?.type === 'MMS' && !hideMMS) {
      if (value?.media == '' && value?.gif == '') {
        err.media = 'Please select media'
      }
    }

    if (value?.message === '') {
      err.message = 'Please provide content of Message'
    }

    setError(err)

    return err
  }

  useEffect(() => {
    dispatch(GetData())
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <WebLink show={popup.webLink} handleClose={() => setPopup({...popup, webLink: false})} />
      <GiphyPopup
        data={userMessage}
        setData={setUserMessage}
        show={giphypopup}
        handleClose={() => {
          setGiphypopup(false)
        }}
      />
      <div className={`card new_message new_template`}>
        <div className='card-header border-0 pt-12 ps-14'>
          <h3 className='card-title align-items-start flex-column me-5 mb-0'>
            <span className='card-label fw-bolder fs-2 mb-1'>
              {param?.state?.data?._id || isEdit
                ? 'Update your Template'
                : 'Create your new Template'}
            </span>
            <span className='text-sm fs-7'>
              Tip: Make sure to name your template something easily recognisable.
            </span>
          </h3>
        </div>
        <div className='card-body py-10 ps-15'>
          <div className='row'>
            <div className='col-lg-12 col-xl-8 col-md-12 col-12 pe-xl-20'>
              {/* <form className='form'> */}
              <div className='mb-7'>
                <label className='form-label'>Template Name</label>
                <input
                  type='text'
                  className='form-control form-control-solid border-0 '
                  placeholder='Template_Name'
                  name='name'
                  value={userMessage?.name}
                  onChange={handleChange}
                />
                <span className='text-danger'>{error.name}</span>
              </div>
              {isAdmin ? (
                <>
                  <div className='mb-7 gap-2'>
                    <label className='form-label'>Apply To</label>
                    <div className='d-flex gap-4'>
                      <div className='form-check form-check-custom form-check-solid mb-2'>
                        <input
                          className='form-check-input'
                          type='radio'
                          value='B-CARD'
                          id='b-card'
                          name='b-card'
                          checked={userMessage?.scope === 'B-CARD'}
                          onChange={() => {
                            setUserMessage({...userMessage, scope: 'B-CARD'})
                          }}
                        />
                        <label className='form-check-label fw-bold' htmlFor='b-card'>
                          B-Card
                        </label>
                      </div>

                      <div className='form-check form-check-custom form-check-solid mb-2'>
                        <input
                          className='form-check-input'
                          type='radio'
                          value='GLOBAL'
                          id='global'
                          name='global'
                          checked={userMessage?.scope === 'GLOBAL'}
                          onChange={() => {
                            setUserMessage({...userMessage, scope: 'GLOBAL'})
                          }}
                        />
                        <label className='form-check-label fw-bold' htmlFor='global'>
                          All Account
                        </label>
                      </div>
                    </div>
                  </div>

                  <div className='mb-7'>
                    <label className='form-label'>Industry</label>
                    <Select
                      value={userMessage?.industry}
                      isSearchable={false}
                      name='industry'
                      onChange={(e: any) => setUserMessage({...userMessage, category: e})}
                      options={IndustryOptions}
                    />
                  </div>
                  <div className='mb-7'>
                    <label className='form-label'>Affiliate</label>
                    <input
                      type='text'
                      className='form-control form-control-solid border-0 '
                      placeholder='Affiliate Code'
                      name='affiliate'
                      value={userMessage?.affiliate}
                      onChange={handleChange}
                    />
                  </div>
                  <div className='mb-7'>
                    <label className='form-label'>Category</label>
                    <Select
                      value={categoryOptions?.find((c) => c.value === userMessage?.category)}
                      isSearchable={false}
                      name='category'
                      onChange={(e: any) => setUserMessage({...userMessage, category: e?.value})}
                      options={categoryOptions}
                    />
                  </div>
                </>
              ) : null}
              <label className='form-label'>Select your message type</label>
              <div className='d-flex mb-8'>
                <div className='w-100 mw-150px me-5'>
                  <input
                    type='radio'
                    className='btn-check'
                    name='radio_buttons_2'
                    value='sms'
                    id='kt_radio_buttons_2_option_2'
                    checked={userMessage?.type == 'SMS'}
                    onChange={() => {
                      setUserMessage({...userMessage, type: 'SMS'})
                    }}
                  />
                  <label
                    className='btn btn-outline btn-outline-dashed btn-outline-default p-5 d-flex align-items-center justify-content-center'
                    htmlFor='kt_radio_buttons_2_option_2'
                  >
                    SMS
                  </label>
                </div>
                {!hideMMS && (
                  <div className='  w-100 mw-150px'>
                    <input
                      type='radio'
                      className='btn-check'
                      name='radio_buttons_2'
                      value='apps'
                      checked={userMessage?.type == 'MMS'}
                      id='kt_radio_buttons_2_option_1'
                      onChange={() => {
                        setUserMessage({...userMessage, type: 'MMS'})
                      }}
                    />

                    <label
                      className='btn btn-outline btn-outline-dashed btn-outline-default p-5 d-flex align-items-center justify-content-center'
                      htmlFor='kt_radio_buttons_2_option_1'
                    >
                      MMS
                    </label>
                  </div>
                )}
              </div>
              {userMessage?.type === 'MMS' && !hideMMS && (
                <div className='mt-5'>
                  <div className='mb-5'>
                    <label className='form-label'>Subject Title</label>
                    <input
                      type='text'
                      className='form-control form-control-solid  border-0'
                      placeholder='Subject Title'
                      name='subjectTitle'
                      value={userMessage.subjectTitle}
                      onChange={handleChange}
                    />
                  </div>
                  <span className='text-danger'>{error.subject}</span>
                  <div className='col-xl-12 col-lg-12 col-md-12 col-sm-12 col-6 mt-5'>
                    <div className=' d-flex flex-column media_dropdown'>
                      <div className=''>
                        <label htmlFor=''>Media</label>
                        <input
                          ref={aRef}
                          accept={'.jpeg,.png'}
                          type='file'
                          name='file'
                          style={{display: 'none'}}
                          onChange={(e: any) => {
                            let data = e.target.files[0]
                            let err = {...error}
                            delete err?.media
                            data?.size > MAX_FILE_SIZE &&
                              setError({
                                ...error,
                                media: 'Upload size should be less than 1.5mb',
                              })
                            data &&
                              data?.size < MAX_FILE_SIZE &&
                              setUserMessage({...userMessage, media: data, gif: ''})
                            setError(err)
                          }}
                        />
                        <input
                          ref={mediaInputVideo}
                          accept={'.jpeg,.png,.jpg,.gif,.mp4,.mp3,video/*..vcf'}
                          type='file'
                          name='file'
                          style={{display: 'none'}}
                          onChange={(e: any) => {
                            let data = e.target.files[0]
                            let err = {...error}
                            delete err?.media

                            data?.size > MAX_FILE_SIZE &&
                              setError({
                                ...error,
                                media: 'Upload size should be less than 1.5mb',
                              })

                            if (data && data?.size < MAX_FILE_SIZE) {
                              setUserMessage({...userMessage, media: data, gif: ''})
                              setError(err)
                            }

                            console.log('data video : ', data)
                          }}
                        />
                        {/* <input
                          ref={aRef}
                          accept={'.jpeg,.png,.jpg,.mp4,.mp3,video/*'}
                          type='file'
                          name='file'
                          style={{display: 'none'}}
                          onChange={(e: any) => {
                            if (e.target.files[0]) {
                              setUserMessage({
                                ...userMessage,
                                media: e.target.files[0],
                                gif: undefined,
                              })
                            }
                          }}
                        /> */}

                        <Select
                          value={{value: '', label: 'Add media'}}
                          isSearchable={false}
                          onChange={(e: any) => {
                            // if (e.value == '1') {
                            //   aRef.current.click()
                            // }
                            if (e.value == '1') {
                              mediaInputVideo.current.click()
                            }
                            if (e.value == '3') {
                              setGiphypopup(true)
                            }
                          }}
                          options={[
                            {value: '1', label: 'Upload File'},
                            // {value: '2', label: 'Upload video'},
                            {value: '3', label: 'Select GIPHY'},
                          ]}
                        />
                        <p
                          style={{
                            whiteSpace: 'nowrap',
                          }}
                          className='m-0 text-muted pt-2'
                        >
                          File size should be less than 1.5 MB.
                        </p>
                      </div>

                      {/* {(userMessage?.media !== '' || userMessage.gif !== '') && (
                        <span
                          className='text-muted fs-7 d-flex flex-row mt-3'
                          style={{width: '200px'}}
                        >
                          Media selected: {userMessage.media !== '' && 'image'}
                          {userMessage.gif !== '' && 'GIF'}{' '}
                          <span className='text-dark fs-7 ms-1 mb-2'></span>
                          <span className='ms-3'>
                            <WSButton
                              type='button'
                              className={
                                'btn btn-sm btn-icon btn-light btn-light-danger fw-500 fs-7 h-100 mh-20px w-20px d-flex justify-content-center align-items-center'
                              }
                              onClick={() => {
                                aRef.current.value = null
                                setUserMessage({...userMessage, media: '', gif: ''})
                              }}
                              iconPath='/media/icons/duotune/arrows/arr061.svg'
                              iconClass='svg-icon-8 mb-1'
                            />
                          </span>
                        </span>
                      )} */}
                      {(userMessage?.media !== '' || userMessage.gif !== '') && (
                        <span className='text-muted fs-7 d-flex flex-row mb-0 mt-3'>
                          Media selected:{userMessage.media !== '' && userMessage.media?.name}
                          {userMessage.gif !== '' && 'GIF'}{' '}
                          <span className='text-dark fs-7 ms-1 mb-2'></span>
                          <span className='ms-2'>
                            <WSButton
                              type='button'
                              className={
                                'btn btn-sm btn-icon btn-light btn-light-danger fw-500 fs-7 h-100 mh-20px w-20px d-flex justify-content-center align-items-center'
                              }
                              onClick={() => {
                                aRef.current.value = null
                                mediaInputVideo.current.value = null
                                setUserMessage({...userMessage, media: '', gif: ''})
                              }}
                              iconPath='/media/icons/duotune/arrows/arr061.svg'
                              iconClass='svg-icon-8 mb-1'
                            />
                          </span>
                        </span>
                      )}
                      <span className='text-danger'>{error.media}</span>
                    </div>
                  </div>
                </div>
              )}
              <MessageBoxV2
                setUserMessage={setUserMessage}
                userMessage={userMessage}
                options={options}
                setPopup={setPopup}
                setError={setError}
                showSelect={['template', 'customfield', 'weblink']}
                error={error}
                isTemplate={true}
                quickSms={userMessage?.type === 'SMS'}
                enableUnicodeModal={true}
              />
              <span className='text-danger'>{error.message}</span>
              <div className='mb-10'>
                <div className='d-flex flex-start'>
                  <button
                    className='btn btn-sm btn-light btn-primary me-2 w-150px p-3 fw-500 me-2'
                    type='button'
                    data-kt-element='send'
                    onClick={handleSave}
                  >
                    {param?.state?.data?._id || isEdit ? 'Update ' : 'Create '} template
                  </button>
                  {/* <Link to={'/template'}>
                    <button
                      className='btn btn-sm btn-light fw-500 text-primary text-hover-white bg-white btn-active-primary w-100px p-3 border border-primary'
                      type='button'
                      data-kt-element='send'
                    >
                      Cancel
                    </button>
                  </Link> */}
                </div>
              </div>
            </div>
            <div className='col-xl-4 col-sm-12 step2-main '>
              <div className='mb-3 text-center'>
                <h2 className='text-dark fw-bold'>Preview</h2>
              </div>
              <div className='newmessage_right newmessage_right_mobile'>
                <nav>
                  <div className='nav nav-tabs' id='nav-tab' role='tablist'>
                    <button
                      className='nav-link active'
                      id='nav-home-tab'
                      data-bs-toggle='tab'
                      data-bs-target='#nav-home'
                      type='button'
                      role='tab'
                      aria-controls='nav-home'
                      aria-selected='true'
                    >
                      {/* <i className='bi bi-unlock'></i> */}
                      <KTSVG path='/media/mobile/Mobile-Unlock.svg' className='svg-icon-2' />
                    </button>
                    <button
                      className='nav-link'
                      id='nav-profile-tab'
                      data-bs-toggle='tab'
                      data-bs-target='#nav-profile'
                      type='button'
                      role='tab'
                      aria-controls='nav-profile'
                      aria-selected='false'
                    >
                      {/* <i className='bi bi-lock'></i> */}
                      <KTSVG path='/media/mobile/Mobile-Lock.svg' className='svg-icon-2' />
                    </button>
                  </div>
                </nav>
                <div className='tab-content' id='nav-tabContent'>
                  <div
                    className='tab-pane fade show active'
                    id='nav-home'
                    role='tabpanel'
                    aria-labelledby='nav-home-tab'
                  >
                    <div
                      className='mobile-bg-wrapper new_mobile'
                      style={{
                        backgroundImage: `url(${toAbsoluteUrl('/media/mobile/NewMobile.png')})`,
                      }}
                    >
                      <div className='mobile-inner'>
                        <div className='mobile-head'>
                          <strong className='msg-mobile-title p-6 d-block text-center px-12'>
                            <KTSVG
                              className='svg-icon-8'
                              path='/media/icons/duotune/arrows/mobile_left_arrow.svg'
                            />
                            0423 3747 2763
                          </strong>
                        </div>

                        <div className='mobile-body'>
                          <div className='message-box'>
                            <div className='time text-center'>Today 14:45</div>
                            {userMessage?.type == 'MMS' && !hideMMS && (
                              <>
                                {userMessage?.subjectTitle !== '' ? (
                                  <div className='messageStyle'>
                                    {' '}
                                    <span>{userMessage?.subjectTitle}</span>{' '}
                                  </div>
                                ) : (
                                  <div className='messageStyle'>
                                    {' '}
                                    <span>{'Engaging Subject title here'}</span>
                                  </div>
                                )}
                                {userMessage?.gif !== '' && userMessage?.gif !== undefined && (
                                  <span>
                                    <img src={userMessage?.gif} alt='poster' />
                                  </span>
                                )}
                                {userMessage?.media !== '' && userMessage?.media !== undefined && (
                                  <>
                                    {typeof userMessage?.media == 'string' && (
                                      <span>
                                        {!userMessage?.mediaType?.split('/')?.includes('video') ? (
                                          <img src={userMessage?.media} alt='poster' />
                                        ) : (
                                          <video
                                            src={userMessage?.media}
                                            width={300}
                                            height={100}
                                            controls
                                          />
                                        )}
                                      </span>
                                    )}
                                    {typeof userMessage?.media !== 'string' && (
                                      <span>
                                        {!userMessage?.media?.type
                                          ?.split('/')
                                          ?.includes('video') ? (
                                          <img
                                            src={URL.createObjectURL(userMessage?.media)}
                                            alt='poster'
                                          />
                                        ) : (
                                          <video
                                            src={URL.createObjectURL(userMessage?.media)}
                                            width={300}
                                            height={100}
                                            controls
                                          />
                                        )}
                                      </span>
                                    )}
                                  </>
                                )}
                              </>
                            )}

                            {userMessage.message !== '' && (
                              <div className='message'>
                                <pre>{removeOptOutOrReply(userMessage?.message)}</pre>
                                <span>{`${
                                  userMessage?.optout !== true
                                    ? "Reply 'STOP' to opt-out"
                                    : 'STOP:{stoptxt.cc/}'
                                }`}</span>
                              </div>
                            )}
                          </div>
                          <div className='send-msg'>
                            <input type='text' />
                            <span
                              className='send_btn'
                              style={{
                                backgroundImage: `url(${toAbsoluteUrl('/media/mobile/send.svg')})`,
                              }}
                            ></span>
                          </div>
                        </div>
                      </div>
                      <div className='wrapper-tabs'>
                        <Tabs
                          defaultActiveKey='notification'
                          className='nav nav-tabs nav-pills border rounded p-2 fs-6 text-dark d-flex justify-content-between'
                        >
                          <Tab eventKey='notification' title='Notification' />
                          <Tab eventKey='message' title='Message' />
                        </Tabs>
                      </div>
                    </div>
                  </div>
                  <div
                    className='tab-pane fade'
                    id='nav-profile'
                    role='tabpanel'
                    aria-labelledby='nav-profile-tab'
                  >
                    <div
                      className='mobile-bg-wrapper grey-bg'
                      style={{
                        backgroundImage: `url(${toAbsoluteUrl('/media/mobile/unlock-screen.svg')})`,
                      }}
                    >
                      <div className='unlock-screen-content'>
                        <div className='notification-outer'>
                          <div className='Notification-item'>
                            <div className='user-icon'>
                              <img
                                alt='Logo'
                                src={toAbsoluteUrl('/media/mobile/user-icon-notification.png')}
                              />
                            </div>
                            <div className='notification-data'>
                              <label htmlFor=''>&#x2329;+61481070030&#12297;</label>
                              <div className='nofication-detail-box'>
                                <p>{userMessage?.message}</p>
                                {userMessage?.type == 'MMS' && !hideMMS && (
                                  <>
                                    {userMessage?.gif !== '' && userMessage?.gif !== undefined && (
                                      <span>
                                        <img src={userMessage?.gif} alt='poster' />
                                      </span>
                                    )}
                                    {userMessage?.media !== '' && userMessage?.media !== undefined && (
                                      <>
                                        {typeof userMessage?.media == 'string' && (
                                          <span>
                                            {!userMessage?.mediaType
                                              ?.split('/')
                                              ?.includes('video') ? (
                                              <img src={userMessage?.media} alt='poster' />
                                            ) : null}
                                          </span>
                                        )}
                                        {typeof userMessage?.media !== 'string' && (
                                          <span>
                                            {!userMessage?.media?.type
                                              ?.split('/')
                                              ?.includes('video') ? (
                                              <img
                                                src={URL.createObjectURL(userMessage?.media)}
                                                alt='poster'
                                              />
                                            ) : null}
                                          </span>
                                        )}
                                      </>
                                    )}
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default CreateScratchV2
